import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import $apiKeys from "@/core/apiKeys/store";

// Выбора владельца здесь нет и не будет: ключ выпускается на учётку сессии,
// другого владельца сервер не принимает даже в обход формы.
const CreateKeyDialog = ({ open, onClose, onCreated }) => {
  const [name, setName] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const onSubmit = async () => {
    setLoading(true);
    try {
      // Ошибку сервера показывает интерсептор — локально её не дублируем.
      const token = await $apiKeys.create(name.trim());
      setName("");
      onCreated(token);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Новый ключ</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body2" sx={{ mb: 2 }}>
          Ключ выпускается на ваш аккаунт и получает ваши права. Название нужно
          только чтобы отличать ключи в списке — например, «ноутбук» или
          «cursor».
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Название"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button
          variant="contained"
          disabled={loading || !name.trim()}
          onClick={onSubmit}
        >
          Выпустить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateKeyDialog;
